/* Layout enhancement only: retains Shopify's existing forms, widgets and event handlers. */
(() => {
  'use strict';
  if (!document.body.classList.contains('dolce-cro-fourpack')) return;
  if (window.__dolceCroMobileV2) return;
  window.__dolceCroMobileV2 = true;
  const productId = '8036248059982';
  const observed = new WeakSet();

  function improvePurchaseLayout(root = document) {
    const formComponent = root.querySelector(`.product-information product-form-component[data-product-id="${productId}"]`)
      || (root.matches?.('.product-information') ? root.querySelector(`product-form-component[data-product-id="${productId}"]`) : null);
    const details = formComponent?.closest('.product-details');
    const buyBlock = formComponent?.closest('.buy-buttons-block');
    if (!details || !buyBlock || !buyBlock.parentElement) return;
    const priceBlock = details.querySelector(`product-price[data-product-id="${productId}"]`);
    const installments = priceBlock?.querySelector(':scope > .installments');

    // Move the existing complete widget/form OUTSIDE the buy form. Never clone or nest forms.
    if (installments && !buyBlock.parentElement.closest('form')) {
      const previous = buyBlock.parentElement.querySelector(':scope > .dolce-cro-installments');
      if (previous && previous !== installments) previous.remove();
      installments.classList.add('dolce-cro-installments');
      buyBlock.after(installments);
    }
    const taxNote = priceBlock?.querySelector(':scope > .tax-note');
    if (taxNote) taxNote.hidden = !taxNote.textContent.trim() && !taxNote.children.length;

    const section = details.closest('.product-information');
    if (!section || observed.has(section)) return;
    observed.add(section);
    let scheduled = false;
    const observer = new MutationObserver((changes) => {
      const relevant = changes.some((change) => [...change.addedNodes].some((node) =>
        node instanceof Element && (node.matches('product-price, .installments, .buy-buttons-block')
          || node.querySelector('product-price, .installments, .buy-buttons-block'))
      ));
      if (!relevant || scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        if (!section.isConnected) { observer.disconnect(); return; }
        improvePurchaseLayout(section);
      });
    });
    observer.observe(section, { childList: true, subtree: true });
  }

  function improveSupportingSections(root = document) {
    root.querySelectorAll('[data-testid="product-list"] .resource-list--grid').forEach((list) => {
      if (!list.hasAttribute('tabindex')) list.setAttribute('tabindex', '0');
      if (!list.hasAttribute('role')) list.setAttribute('role', 'region');
      if (!list.hasAttribute('aria-label')) list.setAttribute('aria-label', 'More citrus products. Scroll to explore.');
    });
    root.querySelectorAll('h1, h2, h3, .text-block > p').forEach((heading) => {
      const text = heading.textContent.replace(/\s+/g, ' ').trim();
      if (!/^(?:[★☆]\s*)*Loved by Our Customers$/i.test(text)) return;
      heading.classList.add('dolce-cro-review-heading');
      const section = heading.closest('.shopify-section');
      if (section && !section.querySelector('.product-information, [data-testid="product-list"]')) {
        section.classList.add('dolce-cro-review-section');
      }
    });
  }
  function init() {
    improvePurchaseLayout();
    improveSupportingSections();
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
